import { useMemo, useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types'

import Icon from '../Icon/Icon';

const Avatar = ({ id, className = '', image = '', alt = 'Avatar Image', size = '', fallbackIcon = null }) => {
  const [imageStatus, setImageStatus] = useState(image ? 'loaded' : 'loading');

  const handleImageLoaded = () => {
    setImageStatus('loaded');
  };

  const commonClasses = 'rounded-lg m-1 bg-inherit overflow-hidden inline-block';

  const avatarClass = classNames(commonClasses, {
    'bg-dark-fill-blue bg-gradient-to-r from-dark-fill-blue via-light-border-blue to-dark-fill-blue bg-no-repeat bg-scroll bg-200%': imageStatus === 'loading' && !fallbackIcon,
  }, className);

  const sizeClass = useMemo(() => {
    switch (size) {
      case 'lg':
        return 'h-20 w-20 rounded-xl';
      case 'sm':
        return 'h-10 w-10 rounded-7';
      default:
        return 'h-16 w-16';
    }
  }, [size]);

  const iconClass = useMemo(() => {
    if (fallbackIcon && !image) {
      return 'h-9/10 w-9/10';
    }
    return '';
  }, [fallbackIcon, image]);

  return (
    <figure id={id} data-role="avatar" className={classNames(avatarClass, sizeClass)}>
      <img
        className={fallbackIcon && !image ? 'hidden' : 'h-full'}
        alt={alt}
        src={image}
        onLoad={handleImageLoaded}
      />
      {fallbackIcon && !image &&
        <Icon icon={fallbackIcon} className={classNames(avatarClass, sizeClass, iconClass)} />
      }
    </figure>
  );
};

Avatar.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  fallbackIcon: PropTypes.string,
  id: PropTypes.string,
  image: PropTypes.string,
  size: PropTypes.oneOf(['lg', 'sm']),
};

export default Avatar;